import _ from "lodash";
import useNotification from "notification";
import { useEffect, useState } from "react";

// Limita a uma mensagem de erro a cada 30s.
const showErrorThrottled = _.throttle(
    (showError, msg) => {
        showError(msg);
    },
    30000,
    { trailing: false }
);

export function useCoordinates() {
    const { showError } = useNotification();

    const [coordinates, setCoordinates] = useState(null);
    const [error, setError] = useState();

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setCoordinates({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                });
                setError(null);
            },
            (error) => {
                console.error("getCurrentPosition", error);
                setCoordinates(null);
                setError(error);

                showErrorThrottled(
                    showError,
                    "Localização indisponível! Certifique-se de ativar a Localização, para georreferenciar os pontos."
                );
            },
            { timeout: 40000, enableHighAccuracy: true }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return [coordinates, error];
}

export function mapUrl(coordinates) {
    return coordinates ? `https://www.google.com/maps/place/${coordinates.lat},${coordinates.lng}` : null;
}

export function mapUrlTestMultipleCoords(coletas) {
    if (Array.isArray(coletas)) {
        let markers = ""
        if (coletas && coletas.length > 0) {
            markers = coletas.map(loc => `${loc.georeferencia?.lat},${loc.georeferencia?.lng}`).join('/');
        } else {
            markers = ""
        }

        const mapUrl = `https://www.google.com/maps/dir/${markers}`;

        return mapUrl
    } else {
        const markers = `${coletas?.lat},${coletas?.lng}`

        const mapUrl = `https://www.google.com/maps/dir/${markers}`;

        return mapUrl
    }
}
